/* eslint-disable func-names */
import React, { useState } from 'react';

import { Link } from 'react-router-dom';

import AnchorLink from 'react-anchor-link-smooth-scroll';

import { Container } from './styles';
import Logo from '~/assets/logo.png';

function Menu() {
  const [tipoMenu, setTipoMenu] = useState(0);
  function handleMenu(tipo) {
    setTipoMenu(tipo);
  }
  return (
    <Container className="fixed-top">
      <div className="container">
        <nav className="navbar navbar-toggleable-sm navbar-expand-lg py-0">
          <div className="col-12">
            <ul className="nav navbar-nav align-items-center">
              <li className="py-5 ml-auto mr-md-1 mr-lg-3 mr-4 nav-item sm-none">
                <AnchorLink href="#sobre" offset={130} title="sobre">
                  sobre
                </AnchorLink>
              </li>
              <li className="py-5 nav-item mx-md-2 mx-lg-3 mx-4 sm-none">
                <hr className="hr-menu" />
              </li>
              <li className="mx-md-1 mx-lg-3 mx-0 w-sm-100 li-logo">
                <div className="row">
                  <div className="col-md-12 col-8">
                    <div className="h-100 d-flex align-items-center">
                      <Link to={`${process.env.PUBLIC_URL}/`} title="home">
                        <img src={Logo} className="py-3" alt="AMZ|b2b" />
                      </Link>
                    </div>
                  </div>
                  <div className="col-4 d-flex justify-content-end text-right md-none">
                    <button
                      className={`${
                        tipoMenu === 2 ? 'is--active' : ''
                      } menu-btn my-3`}
                      aria-labelledby="sr-only"
                      type="button"
                      onClick={() =>
                        tipoMenu === 2 ? handleMenu(1) : handleMenu(2)
                      }
                    >
                      <span className="sr-only" id="sr-only">
                        Menu
                      </span>
                      <div className="menu-btn__icon" aria-hidden="true">
                        <span className="icon icon--menu">
                          <span />
                          <span />
                          <span />
                        </span>
                        <span className="icon icon--close">
                          <span />
                          <span />
                        </span>
                      </div>
                    </button>
                  </div>
                </div>
              </li>
              <li className="py-5 nav-item mx-md-2 mx-lg-3 mx-4 sm-none">
                <hr className="hr-menu" />
              </li>
              {/* <li className="py-5 nav-item mx-md-1 mx-lg-3 mx-4 sm-none">
                <a
                  href="tel:(55) 11 98224-2385"
                  title="whatsapp"
                  onClick={() => window.wpp_conversion()}
                >
                  Whatsapp
                </a>
              </li> */}
              {/* <li className="py-5 nav-item sm-none">
                <a
                  href="tel:(55) 11 98224-2385"
                  title="whatsapp"
                  onClick={() => window.wpp_conversion()}
                >
                  (55) 11 98224.2385
                </a>
              </li> */}
            </ul>
          </div>
        </nav>
        <div
          className={` ${
            // eslint-disable-next-line no-nested-ternary
            tipoMenu === 0
              ? 'd-none'
              : tipoMenu === 1
              ? 'slide-out-left d-none'
              : 'slide-in-left'
          } vh-100 md-none`}
        >
          <ul>
            <li className="py-3">
              <AnchorLink
                onClick={() => (tipoMenu === 2 ? handleMenu(1) : handleMenu(2))}
                href="#sobre"
                title="sobre"
              >
                sobre
              </AnchorLink>
              <hr className="dropdown-divider" />
            </li>
            <li className="py-3">
              <AnchorLink
                onClick={() => (tipoMenu === 2 ? handleMenu(1) : handleMenu(2))}
                href="#contato"
                offset={130}
                title="contato*"
              >
                contato
              </AnchorLink>
              <hr className="dropdown-divider" />
            </li>
            <li className="py-3">
              <a
                onClick={() => (tipoMenu === 2 ? handleMenu(1) : handleMenu(2))}
                href="tel:(55) 11 4191.1578"
                title="whatsapp"
              >
                (55) 11 4191.1578
              </a>
              <br />
              <a
                onClick={() => (tipoMenu === 2 ? handleMenu(1) : handleMenu(2))}
                href="tel:(55) 11 98224-2385"
                title="whatsapp"
              >
                (55) 11 98224-2385
              </a>
            </li>
          </ul>
        </div>
      </div>
    </Container>
  );
}

export default Menu;
